/* eslint-disable max-classes-per-file */
import { loggerConstants } from './logger.constants';
import { EventRow } from './logger.event-row';

/**
 * This event will be reported as a Geneva metric, it will be used together with ActionFailedEventRow to monitor the status of an action
 */
export class ActionSucceedEventRow extends EventRow {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(private action: string, properties?: Record<string, any>) {
        super(loggerConstants.Event_ActionResult, properties);
        this.addToProperties('action', this.action);
        this.addToProperties('isSuccessful', true);
    }
}

/**
 * This event will be reported as a Geneva metric, it will be used together with ActionSucceedEventRow to monitor the status of an action
 */
export class ActionFailedEventRow extends EventRow {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(private action: string, private error?: any, properties?: Record<string, any>) {
        super(loggerConstants.Event_ActionResult, properties);
        this.addToProperties('action', this.action);
        this.addToProperties('isSuccessful', false);
        this.addToProperties('error', this.error);
    }
}
